export default "__VITE_ASSET__Dol9BfEf__$_?nuxt_component=async&nuxt_component_name=IconFire&nuxt_component_export=default__"